import { useEffect, useMemo } from "react";

type Props = {
  /** Winning position index (0-9) — green landed here, not on yours. */
  result: number;
  onDone: () => void;
};

const ARROW_COUNT = 12;

/** A greyed archery arrow tumbling down — the shots that missed. */
function MissArrow() {
  return (
    <svg viewBox="0 0 120 22" aria-hidden>
      <rect x="12" y="9.6" width="86" height="2.8" rx="1.4" fill="#7a7a7a" />
      <path d="M119 11 L96 4.5 L101.5 11 L96 17.5 Z" fill="#b9b9b9" stroke="#6a6a6a" strokeWidth="0.6" />
      <path d="M14 10.4 L2 2.5 L8.5 11 L2 19.5 L14 11.6 Z" fill="#8a8a8a" />
      <rect x="0" y="9" width="4" height="4" rx="1" fill="#5a5a5a" />
    </svg>
  );
}

export function LoseCelebration({ result, onDone }: Props) {
  useEffect(() => {
    const t = setTimeout(onDone, 6000);
    return () => clearTimeout(t);
  }, [onDone]);

  const arrows = useMemo(
    () =>
      Array.from({ length: ARROW_COUNT }, () => ({
        left: 3 + Math.random() * 90,
        width: 55 + Math.random() * 55,
        dur: 1.5 + Math.random() * 1.5,
        delay: Math.random() * 2.4,
        rot: 20 + Math.random() * 60,
      })),
    []
  );

  return (
    <div className="lose-overlay" role="alert" onClick={onDone}>
      {arrows.map((a, i) => (
        <span
          key={i}
          className="lose-arrow"
          style={
            {
              left: `${a.left}%`,
              width: a.width,
              "--dur": `${a.dur}s`,
              "--delay": `${a.delay}s`,
              "--rot": `${a.rot}deg`,
            } as React.CSSProperties
          }
        >
          <MissArrow />
        </span>
      ))}

      <div className="lose-banner" onClick={(e) => e.stopPropagation()}>
        <span className="lose-title">BETTER LUCK NEXT TIME</span>
        <span className="lose-sub">
          GREEN LANDED ON <strong>P{result + 1}</strong>
        </span>
        <button className="win-close" onClick={onDone}>
          CLOSE
        </button>
      </div>
    </div>
  );
}
